import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login/Login'
import Dashboard from '@/components/Home/Dashboard'
import Customers from '@/components/Modules/Customers'
import Emails from '@/components/Modules/Emails'
import DeepEmails from '@/components/Modules/DeepEmails'
import Products from '@/components/Modules/Products'
import MessageBoard from '@/components/Modules/MessageBoard'
import Users from '@/components/Modules/Users'
import ChatGPT from '@/components/Modules/ChatGPT'
import Tools from '@/components/Modules/Tools'
import ALCMailer from '@/components/Modules/ALCMailer'
import SharedFiles from '@/components/Modules/SharedFiles'
import Schedule from '@/components/Modules/Schedule'
import WebsitesIndex from '@/components/Modules/Websites/Index'
import WebsitesList from '@/components/Modules/Websites/List'
import WebsitesDetail from '@/components/Modules/Websites/Detail'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      redirect: 'dashboard'
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: Dashboard
    },
    {
      path: '/customers',
      name: 'customers',
      component: Customers
    },
    {
      path: '/emails',
      name: 'emails',
      component: Emails
    },
    {
      path: '/deep_emails',
      name: 'deep_emails',
      component: DeepEmails
    },
    {
      path: '/products',
      name: 'products',
      component: Products
    },
    {
      path: '/message_board',
      name: 'message_board',
      component: MessageBoard
    },
    {
      path: '/users',
      name: 'users',
      component: Users
    },
    {
      path: '/schedule',
      name: 'schedule',
      component: Schedule
    },
    {
      path: '/chatgpt',
      name: 'chatgpt',
      component: ChatGPT
    },
    {
      path: '/tools',
      name: 'tools',
      component: Tools
    },
    {
      path: '/alc_mailer',
      name: 'alc_mailer',
      component: ALCMailer
    },
    {
      path: '/shared_files',
      name: 'shared_files',
      component: SharedFiles
    },
    {
      path: '/websites',
      name: 'websites',
      component: WebsitesIndex
    },
    {
      path: '/websites/list',
      name: 'websites_list',
      component: WebsitesList
    },
    {
      path: '/websites/detail/:domain',
      name: 'websites_detail',
      component: WebsitesDetail
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js